/**
 * LabelHistoryList — the "Last 10 labels" sidebar list. Pure render based on
 * the labels array; no fetching or mutation responsibilities.
 */
import { Badge } from "@/components/ui/badge";

export default function LabelHistoryList({ labels }) {
  return (
    <div className="mt-6 surface p-5 no-print">
      <div className="label-eyebrow mb-3">Last 10 labels</div>
      {labels.length === 0 ? (
        <div className="text-sm text-charcoal-soft">No labels yet.</div>
      ) : (
        <ul className="divide-y divide-[color:var(--border)] text-sm">
          {labels.map((l) => (
            <li key={l.id} className="py-2 flex items-center justify-between gap-2">
              <div>
                <div className="font-medium">{l.product_name}</div>
                <div className="text-xs font-mono text-charcoal-soft">
                  {l.batch_number} · use-by {l.use_by_date}
                </div>
              </div>
              <Badge variant="outline" className="text-xs">{l.storage}</Badge>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
